import {
  ClinicApiKeyResource,
  clinicApiKeyResourceSchema,
} from "@client/resources/ClinicApiKeyResource";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { object } from "yup";

export type FetchApiIntegrationResponse =
  ApiResponse<ClinicApiKeyResource | null>;

export const fetchApiIntegration =
  async (): Promise<FetchApiIntegrationResponse> => {
    const response = await fetchData(
      "/dietitian/clinic/api-integration",
      APIMethods.GET,
    );

    return await schema
      .validate(response)
      .catch(logFetchValidateError("/dietitian/clinic/api-integration"));
  };

const schema = object({
  data: clinicApiKeyResourceSchema.nullable().defined(),
});
